import { ROLE_TYPE } from "@supplier/meta";
import salesManageRouter from "./salesManage";
import purchasingManageRouter from "@/routers/purchaseSalesInventory/purchaseManagement";
import contractRouter from "@/routers/purchaseSalesInventory/contractManagement";
import fundRouter from "@/routers/purchaseSalesInventory/fundMangement";
import financingRouter from "@/routers/purchaseSalesInventory/financing";
import invoiceRouter from "@/routers/purchaseSalesInventory/invoice";
import storageRouter from "@/routers/purchaseSalesInventory/storage";
import logisticsRouter from "@/routers/purchaseSalesInventory/logistics";
import statementStatisticsRouter from "@/routers/purchaseSalesInventory/statementStatistics";
import accountsPayableRouter from "@/routers/purchaseSalesInventory/accountsPayable";
import { UserStore } from "@/stores/user";
import { hasPurchaseSalesInventory } from "@/utils/permission";
import { AccountStore, AccountType } from "@/stores/account";

export const purchaseSalesInventoryRouters = [
    {
        path: "/purchaseSalesInventory",
        name: "PurchaseSalesInventory",
        meta: {
            title: "进销存管理",
            icon: "icon-jinxiaocun",
            hidden: ({ userStore, accountStore }: { userStore: UserStore; accountStore: AccountStore }) => {
                let roles = userStore.userInfo.proxyAccount?.roles;
                // 关联企业是跟随主账号的角色权限
                if (accountStore.accountType === AccountType.ASSOCIATED) {
                    roles = userStore.userInfo.customer?.roles;
                }
                // 进销存管理和仓储业务根据企业身份展示，拥有采购客户身份才展示进销存管理，拥有仓储客户身份才展示仓储业务。
                return (
                    !roles?.includes(ROLE_TYPE.PURCHASE_CUSTOMER.code) ||
                    (accountStore.isSubAccount && !hasPurchaseSalesInventory(userStore.userInfo.permissions))
                );
            }
        },
        children: [
            ...purchasingManageRouter,
            ...salesManageRouter,
            ...contractRouter,
            ...fundRouter,
            ...financingRouter,
            ...accountsPayableRouter,
            ...invoiceRouter,
            ...logisticsRouter,
            ...storageRouter,
            ...statementStatisticsRouter
        ]
    }
];
